import { lazy, startTransition } from "react";
import CustomImage from "../../core/CustomImage/CustomImage";
import CustomIcon from "../../core/CustomIcon/CustomIcon";
import classes from "./Header.module.scss";
import classnames from "classnames";
import { nanoid } from "nanoid";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useIsMobile from "../../hooks/useIsMobile";
import { APP_PATH, routePath } from "../../../routes/route";
import logo from "../../../assets/icons/logo.svg";
import myKarelogo from "../../../assets/icons/mykare_logo.svg";
import chat from "../../../assets/icons/chat.svg";
import arrow_down from "../../../assets/icons/chevron_arrow.svg";
import hamburger from "../../../assets/icons/hamburger.svg";
import Offcanvas from "../../core/Offcanvas/Offcanvas";
import { lang, tabs } from "../../../global/constant";

const Chatbot = lazy(() => import("../Chatbot/Chatbot"));

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile({ breakpoint: 992 });
  const [language, setLanguage] = useState(lang[0]);
  const [show, setShow] = useState(false);
  const [activeTab, setActiveTab] = useState(routePath.home.path);
  const [openChat, setOpenChat] = useState(false);

  const handleDropdown = () => {
    var element = document.getElementById("langDropdown");
    if (element) {
      if (element.classList.contains(classes.active)) {
        element.classList.remove(classes.active);
      } else {
        element.classList.add(classes.active);
      }
    }
  };

  const handleOption = (para) => {
    setLanguage(para);
    document.getElementById("langDropdown").classList.remove(classes.active);
  };

  const handleClick = (e, tab, innertab) => {
    startTransition(() => {
      if (innertab) {
        setActiveTab(`${tab}/${innertab}`);
        navigate(`${tab}/${innertab}`);
      } else {
        setActiveTab(tab);
        navigate(`${tab}`);
      }
      if (isMobile) {
        window.location.reload();
      }
    });
    e.stopPropagation();
  };

  return (
    <>
      <div className={classnames(classes.main__container)}>
        <div className={classnames(classes.container, "containerWidth")}>
          {isMobile && (
            <>
              <div>
                <CustomImage
                  src={hamburger}
                  alt="Menu"
                  title="Menu"
                  height={16}
                  style={{ marginRight: 20, cursor: "pointer" }}
                  clickHandler={() => setShow(true)}
                />
              </div>
              <Offcanvas show={show} close={() => setShow(!show)}>
                <div style={{ textAlign: "left", paddingTop: "20px" }}>
                  <CustomImage
                    src={myKarelogo}
                    alt="Paytm Cloud Solution"
                    title="Paytm Cloud Solution"
                    /* height={20} */
                    style={{ paddingLeft: "16px", cursor: "pointer" }}
                    clickHandler={() => navigate(routePath.home.path)}
                  />
                </div>
                <div
                  className={classnames(
                    classes.mobileNumber,
                    classes.mobileScreen
                  )}
                >
                  <span>Connect with Sales:</span>
                  <a href="tel:080-42547226">080-42547226</a>
                </div>
                <ul className={classnames(classes.menulistMobile)}>
                  {tabs.map((tab) => {
                    return (
                      <li
                        onClick={(e) => handleClick(e, tab.id)}
                        key={nanoid()}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className={`${
                            location.pathname === tab.id
                              ? classes.activePage
                              : ""
                          }`}
                        >
                          {tab.title}
                        </div>
                        {tab.innerTabs && (
                          <ul
                            className={classnames(classes.menulistMobile)}
                            style={{ marginTop: 10 }}
                          >
                            {tab.innerTabs.map((innertab) => {
                              return (
                                <li
                                  onClick={(e) =>
                                    handleClick(e, tab.id, innertab.id)
                                  }
                                  key={nanoid()}
                                  style={{ cursor: "pointer" }}
                                  className={classnames(classes.innertabLi)}
                                >
                                  <div
                                    className={`${
                                      activeTab === `${tab.id}/${innertab.id}`
                                        ? classes.activePage
                                        : ""
                                    }`}
                                  >
                                    {innertab.name}
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </Offcanvas>
            </>
          )}
          <div>
            <CustomImage
              src={myKarelogo}
              alt="Paytm Cloud Solution"
              title="Paytm Cloud Solution"
              /* height={20} */
              style={{
                cursor: "pointer",
                position: "relative",
                top: isMobile ? "-7px" : 0,
              }}
              clickHandler={() => navigate(routePath.home.path)}
            />
          </div>

          {!isMobile && (
            <>
              <div className={classnames(classes.mobileNumber)}>
                <span>Connect with Sales:</span>
                <a href="tel:080-42547226">080-42547226</a>
              </div>
              <ul className={classnames(classes.menulist)}>
                {tabs.map((tab) => {
                  return (
                    <li
                      onClick={(e) => handleClick(e, tab.id)}
                      className={`${
                        location.pathname === tab.id ? classes.activePage : ""
                      }`}
                      key={nanoid()}
                    >
                      {tab.title}
                    </li>
                  );
                })}
              </ul>
            </>
          )}
          <div
            className={classnames(classes.chat)}
            onClick={() => setOpenChat(true)}
          >
            <CustomIcon src={chat} alt="Let’s Chat" title="Let’s Chat" />
            <div className={classnames(classes.text)}>Let’s Chat</div>
          </div>
          <div className={classnames(classes.dropdown)}>
            <button
              className={classnames(classes.dropdowntoggle)}
              type="button"
              onClick={handleDropdown}
            >
              <div className={classnames(classes.dropdownitem)}>
                <CustomIcon
                  src={language.flag}
                  alt={language.flag}
                  title={language.flag}
                  style={{ border: "2px solid #CBD5E1", borderRadius: "50px" }}
                />
                <div>{language.name}</div>
                <CustomIcon src={arrow_down} alt="dropdown" />
              </div>
            </button>
            <ul className={classnames(classes.dropdownmenu)} id="langDropdown">
              {lang.map((option) => {
                return (
                  <li key={nanoid()} onClick={() => handleOption(option)}>
                    <div className={classnames(classes.dropdownitem)}>
                      <CustomIcon
                        src={option.flag}
                        alt={option.name}
                        title={option.name}
                      />
                      <div>{option.name}</div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <Chatbot show={openChat} setOpenChat={setOpenChat} />
    </>
  );
};
export default Header;
